import Vue from 'vue'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '@js/mixins.js'
import Singleselect from '@component/dccore-form/singleselect.vue'
import TextInput from '@component/dccore-form/textInput.vue'
import { BModal } from 'bootstrap-vue/es/components/modal'

if ($('#push_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#push_form',
    components: {
      RingLoader,
      TextInput,
      Singleselect,
      BModal
    },
    mixins: [mixins],
    data: {
      loading: 0,
      form: {
        entity: {},
        options: {
          brands: [],
          errors: {},
        }
      },
    },
    mounted() {
      this.getBrands()
      document.querySelector('#button-save-and-back').innerText = this.trans('push.form.save_btn')
    },
    methods: {
      createPush() {
        this.$refs.confirmationModal && this.$refs.confirmationModal.show()
      },
      savePush() {
        this.$refs.confirmationModal && this.$refs.confirmationModal.hide()

        this.loading++
        const url = Routing.generate('api_post_push')
        const data = { data: this.form.entity }

        this.$http.post(url, data).then(() => {
          window.location.href = Routing.generate('push_grid')
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options, response.data.message)
        })
      },
      getBrands() {
        this.loading++
        const url = Routing.generate('api_get_push_brands', { context: 'dropdown' })

        this.$http.get(url).then(response => {
          this.form.options.brands = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
    }
  })
}
